const key = Symbol();

const setInfowindowContent = (typologyTable, project) => {

  let year = project.year ?? '';
  let title = project.title ?? '';
  let url = project.url ?? '';
  let neighborhood = project.neighborhood && project.neighborhood.length ? project.neighborhood[0].title : '';
  let designer = project.designer && project.designer.length ? project.designer[0].title : '';
  let typologies = project.typologies ?? [];

  let typologiesString = '';

  for (const typology of typologies) {
    const id = typology.id;
    if (typologyTable[id]) {
      typologiesString += `
      <li class="list-inline-item card-typology" style="color:${typologyTable[id].color}" title="${typologyTable[id].title}">
      <span class="visually-hidden">${typologyTable[id].title}</span>
      </li>`
    }
  }

  const content = `<div class="card card-infowindow">
    <div class="card-inner">
      <div class="card-face card-face-back">
        <dl> ${year ?
            `<div class="card-group">
              <dt class="card-key">Year</dt>
              <dd class="card-value">${year}</dd>
            </div>`
            : ''}
            ${title ?
            `<div class="card-group card-group-title">
              <dt class="visually-hidden">Title</dt>
              <dd class="card-value">
                <a href="${url}">${title}</a>
              </dd>
            </div>`
            : ''}
            ${neighborhood ?
            `<div class="card-group">
              <dt class="card-key">Neighborhood</dt>
              <dd class="card-value">${neighborhood}</dd>
            </div>`
            : ''}
            ${designer ?
            `<div class="card-group">
              <dt class="card-key">Designer</dt>
              <dd class="card-value">${designer}</dd>
            </div>`
            : ''}
            ${typologies.length ?
            `<div class="card-group card-group-typology">
              <dt class="card-key">Typology</dt>
              <dd class="card-value">
                <!-- svelte-ignore a11y-no-redundant-roles -->
                <ul class="list-inline" role="list">
                  ${typologiesString}
                </ul>
              </dd>
            </div>`
          : ''}
        </dl>
      </div>
    </div>
  </div>`;

  return content;
}


export { key, setInfowindowContent };
